import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PublicToolbarComponent } from '../../shared/ui/public-toolbar/public-toolbar.component';
import { FooterComponent } from '../../shared/ui/footer/footer.component';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [RouterOutlet, PublicToolbarComponent, FooterComponent],
  templateUrl: './public-layout.component.html',
  host: { class: 'layout-public' }
})
export class PublicLayoutComponent {}
